import React, { useState } from "react";
import {
  FormControl,
  InputAdornment,
  TextField,
  createStyles,
  makeStyles
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles(() => {
  return createStyles({
    search: {
      margin: "0"
    }
  });
});

const SearchBar = ({ searchText, setSearchText }) => {
  const { search } = useStyles();
  const [showClearIcon, setShowClearIcon] = useState("none");

  const handleChange = (event) => {
    setSearchText(event.target.value)
    setShowClearIcon(event.target.value === "" ? "none" : "flex");
  };

  const handleClear = () => {
    setSearchText("")
    setShowClearIcon('none')
  };

  return (
    <div id="app" className="mb-2">
      <FormControl className={search} style={{ width: '100%' }}>
        <TextField
          size="small"
          variant="outlined"
          value={searchText}
          onChange={handleChange}
          placeholder={"Search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment
                position="end"
                style={{ display: showClearIcon }}
                onClick={handleClear}
              >
                <ClearIcon />
              </InputAdornment>
            )
          }}
        />
      </FormControl>
    </div>
  );
};

export default SearchBar;
